module.exports = __webpack_public_path__ + "assets/img/lpjl.52dba6e1.png";